export const hideSuggestions = () => {
    const el = document.getElementsByClassName(
        "ant-select-selection-search-input"
    );
    for (let i = 0, elLength = el.length; i < elLength; i++) {
        el[i].setAttribute(
            "autocomplete",
            "registration-select"
        );
    }

    const elInput = document.getElementsByClassName(
        "ant-input"
    );
    for (let i = 0, elInputLength = elInput.length; i < elInputLength; i++) {
        elInput[i].setAttribute(
            "autocomplete",
            "registration-select"
        );
    }
}

export const validateNameMessages = {
    required: '${name} is required.',
    types: {
        email: '${name} is not validate email.',
        number: '${name} is not a validate number.',
    },
    number: {
        range: '${name} must be between ${min} and ${max}.',
    },
};

export const validateLabelMessages = {
    required: '${label} is required.',
    types: {
        email: '${label} is not validate email.',
        number: '${label} is not a validate number.',
    },
    number: {
        range: '${label} must be between ${min} and ${max}.',
    },
};


export const roundOffDigits = (num) => {
    return +(Math.round((num + Number.EPSILON) * 100) / 100).toFixed(2);
}

export const fixedDecimal = (num) => {
    return Number.parseFloat(num).toFixed(2);
  }